"use client";

import {convertMTOKM} from "@/libs/helper";
import {tableService} from "@/service/table.service";
import {Progress} from "@nextui-org/react";
import {useEffect, useState} from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import NoDataFound from "./commonTemplate/noDataFound";
import SideBarLoader from "./commonTemplate/sideBarLoader";

type NeoSideBarCardProps = {
  sideBar: sideBar;
  request: any;
  setSidebarReqData: any;
};
type sideBar = {
  type: string;
  api_url: string;
  menu?: string;
};
type VehicleDistanceData = {
  instituteName: string;
  vehicleName: string;
  trackerId: string;
  scheduled: number;
  unScheduled: number;
};

type ProcessedVehicleDistanceData = VehicleDistanceData & {
  total: number;
  scheduledPercent: string;
  unScheduledPercent: string;
  scheduledKM: string;
  unScheduledKM: string;
  totalKM: string;
};
export const DrivenReport: React.FC<NeoSideBarCardProps> = ({
  sideBar: sidebar,
  request: request,
  setSidebarReqData: setSidebarReqData
}) => {
  const [sideBarData, setSidebarData] = useState<any>([]);
  const [currentTrackerId, setCurrentTrackerId] = useState<any>(0);
  const [metaDate, setMetaDate] = useState<any>([]);
  const [page, setPage] = useState<number>(1);
  const [hasMore, setHasMore] = useState<boolean>(true);
  const [isSidebarLoading, setSidebarIsLoading] = useState(false);
  useEffect(() => {
    if (sidebar && sidebar.api_url && request) {
      fetchData();
    }
  }, [sidebar, request]);
  const fetchData = async () => {
    setSidebarIsLoading(true);
    const results = await tableService.onGet(sidebar.api_url, 4, request);
    setMetaDate(results.meta);
    if (results.rows.length > 0) {
      if (results.meta && results.meta.currentPage === 1) {
        setSidebarData(processDistanceDrivenData(results.rows));
      } else {
        setSidebarData((prevData: any) => [
          ...prevData,
          ...processDistanceDrivenData(results.rows)
        ]);
      }

      if (request.pageNumber === results.meta.totalPages) {
        setHasMore(false);
      } else {
        setHasMore(true);
      }
    } else {
      setHasMore(true);
      setMetaDate([]);
      setSidebarData([]);
    }
    setSidebarIsLoading(false);
  };
  useEffect(() => {
    if (sideBarData && sideBarData.length > 0) {
      if (!currentTrackerId) {
        const firstTrackerId = sideBarData[0].trackerId;
        request.trackerId = firstTrackerId;
        setCurrentTrackerId(firstTrackerId);
        setSidebarReqData(request);
      } else {
        // its ignored api call when load more sidebar data
        if (currentTrackerId !== request.trackerId) {
          request.trackerId = currentTrackerId;
          setSidebarReqData(request);
        }
      }
    }
  }, [sideBarData]);
  const changeVehicle = (trackerid: string) => {
    request.trackerId = trackerid;
    setSidebarReqData(request);
    setCurrentTrackerId(trackerid);
  };
  function processDistanceDrivenData(
    response: VehicleDistanceData[]
  ): ProcessedVehicleDistanceData[] {
    return response.map(item => {
      const total = item.scheduled + item.unScheduled;
      const scheduledPercent = calculatepercentage(item.scheduled, total);
      const unScheduledPercent = calculatepercentage(item.unScheduled, total);
      return {
        ...item,
        total,
        scheduledPercent,
        unScheduledPercent,
        scheduledKM: convertMTOKM(item.scheduled),
        unScheduledKM: convertMTOKM(item.unScheduled),
        totalKM: convertMTOKM(total)
      };
    });
  }

  const calculatepercentage = (value: any, total: any) => {
    let percentage = "0";
    if (total > 0) {
      percentage = ((value / total) * 100).toFixed(2);
    }
    return percentage;
  };

  const loadMore = () => {
    const nextPage = metaDate.currentPage + 1;
    request.pageNumber = nextPage;
    fetchData();
  };
  return (
    <div>
      {isSidebarLoading && request.pageNumber && request.pageNumber == 1 ? (
        <SideBarLoader />
      ) : (
        <>
          {sideBarData && sideBarData.length == 0 ? (
            <NoDataFound />
          ) : (
            <div
              id="scrollableModal"
              className="h-[calc(100vh-100px)] overflow-y-auto"
            >
              <InfiniteScroll
                dataLength={sideBarData.length}
                next={loadMore}
                hasMore={hasMore}
                loader={<h4 className="text-center">Loading...</h4>}
                endMessage={
                  <p className="text-center text-gray-500">No more items</p>
                }
                scrollableTarget="scrollableModal"
                scrollThreshold={0.8} // Load when 80% scrolled
              >
                {sideBarData.map((data: any, index: number) => {
                  return (
                    <div
                      className="w-full max-w-md rounded-lg border bg-white p-4 shadow-md "
                      key={index}
                    >
                      <div className="flex flex-col items-center justify-between border-b-2 pb-2">
                        <h3 className="text-base font-medium text-gray-700 ">
                          {data.vehicleName}
                        </h3>
                        <span className="text-xs text-gray-500 ">
                          {data.instituteName}
                        </span>
                      </div>

                      <div className="mt-2 flex items-center justify-between">
                        <div className=" text-center">
                          <p className="text-sm font-medium text-green-500">
                            Scheduled
                          </p>
                          <div className="flex items-center gap-4">
                            <Progress
                              aria-label="Loading..."
                              size="sm"
                              value={data.scheduledPercent}
                              color="success"
                              className="flex-1"
                            />
                            <span className="text-xs text-default-500">
                              {data.scheduledPercent}%
                            </span>
                          </div>
                          <p className="text-xl font-bold">
                            {data.scheduledKM}
                          </p>
                        </div>

                        <div className=" text-center">
                          <p className="text-sm font-medium text-red-500">
                            Unscheduled
                          </p>
                          <div className="flex items-center gap-4">
                            <Progress
                              aria-label="Loading..."
                              size="sm"
                              value={data.unScheduledPercent}
                              color="danger"
                              className="flex-1"
                            />
                            <span className="text-xs text-default-500">
                              {data.unScheduledPercent}%
                            </span>
                          </div>
                          <p className="text-xl font-bold">
                            {data.unScheduledKM}
                          </p>
                        </div>
                      </div>

                      <button
                        className={`mt-2 w-full rounded-lg py-1 text-sm font-medium transition ${
                          currentTrackerId === data.trackerId
                            ? "bg-green-700 text-white"
                            : "bg-neo-white text-neo-black hover:bg-green-700"
                        }`}
                        onClick={() => changeVehicle(data.trackerId)}
                      >
                        View Details →
                      </button>
                    </div>
                  );
                })}
              </InfiniteScroll>
            </div>
          )}
        </>
      )}
    </div>
  );
};
